import { Typography } from 'seagull';
import { utils } from "../../../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BillingStageRow = _ref => {
  let {
    name,
    price,
    billingStages
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Typography, {
      testId: "billing-stage-row-test-service-price",
      children: "".concat(name, " - ").concat(utils.formatDollarAmount(price))
    }), /*#__PURE__*/_jsxs(Typography, {
      testId: "billing-stage-row-test-service-stage",
      variant: "paragraph2",
      skin: "secondary",
      children: ["Stage ", billingStages.number, "/", billingStages.total]
    })]
  });
};
export default BillingStageRow;